import { render, staticRenderFns } from "./collibelonging.vue?vue&type=template&id=3dae29e3&"
import script from "./collibelonging.vue?vue&type=script&lang=js&"
export * from "./collibelonging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports